import { render, staticRenderFns } from "./FormUpdateAddons.vue?vue&type=template&id=afc795b8&"
import script from "./FormUpdateAddons.vue?vue&type=script&lang=js&"
export * from "./FormUpdateAddons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports